module.exports = __webpack_public_path__ + "img/13.c2467ef1.jpg";